import React from "react";
import { Outlet } from "react-router";
import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { LoadingComponent } from "./LoadingComponent";
import Cookies from "universal-cookie";
import useRedirectToErrorPage from "../pages/errors/hooks/redirectToErrorPage";

export default function PrivateRoute() {
  const [clientCode, setClientCode] = useState();
  const [errorMessage, setErrorMessage] = useState();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const cookies = new Cookies();
  useRedirectToErrorPage(errorMessage);

  // Checks if there is any cookie clientCode
  useEffect(() => {
    try {
      let resolvedClientCode;

      if (
        typeof searchParams.get("code") !== "undefined" &&
        searchParams.get("code") !== null &&
        searchParams.get("code") !== ""
      ) {
        resolvedClientCode = searchParams.get("code");
        cookies.set("clientCode", resolvedClientCode, {
          path: "/",
          sameSite: "None",
          secure: true,
        });
      } else {
        resolvedClientCode = cookies.get("clientCode");
      }

      setClientCode(resolvedClientCode ?? null);
    } catch (err) {
      setErrorMessage("Si è verificato un errore. Il link firma utilizzato non è valido, riprovare con un nuovo link.")
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (typeof clientCode === "undefined") {
      return;
    }

    if (!clientCode) {
      setErrorMessage("Si è verificato un errore. Il link firma utilizzato non è valido, riprovare con un nuovo link.")
      return;
    }

    axios.get(`https://app.deb00.it/api/get-client-by-code/${encodeURIComponent(clientCode)}`
    )
      .then((response) => {
        if (response.data["status"] !== "success") {
          setErrorMessage(`Si è verificato un errore. Rieffettuare la procedura con un nuovo link. Se l'errore persiste contattare l'assistenza.`)
        } else {
          const wizardCompleted = String(
            response.data["data"]["wizard_completed"] ??
              response.data["data"]["wizard_completato"] ??
              ""
          ).toLowerCase();

          if (wizardCompleted === "si" || wizardCompleted === "yes")
            navigate('/pannello-firma-contratti', { state: { email: response.data["data"]["email"] } });
          else {
            navigate('/');
          }
        }
      }).catch((error) => {
        if (error.response?.status === 422) {
          setErrorMessage("Si è verificato un errore. Il link firma utilizzato non è valido, riprovare con un nuovo link.")
          return;
        }
        setErrorMessage(`Si è verificato un errore. Rieffettuare la procedura con un nuovo link. Se l'errore persiste contattare l'assistenza.`)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientCode, navigate]);

  return (
    <>
      <Header />
      {clientCode ? (
        <Outlet context={clientCode} />
      ) : (
        <LoadingComponent />
      )}
      <div className="h-8" />
    </>
  );
}

const Header = () => {
  return (
    <>
      <div className="bg-orange-500 w-full h-24 flex flex-row justify-center items-center">
        <img
          src={require("../assets/debitoo_logo.png")}
          className="h-12 lg:h-16 max-w-full"
          alt="logo"></img>
      </div>
      <div className="h-12" />
    </>
  );
};
